
import React from 'react';
import {
    Grid,
    Typography,
} from "@mui/material";
import "./styles.css";

const JobDetails = () => {
    return (
        <Grid className="category" style={{ height: '150px' }}>
            <Grid display='flex' flexDirection='column' style={{ margin: '2%', paddingTop: '10px' }} >
                <Typography style={{ color: '#008EA1', fontSize: '15px' }}>Job Details</Typography>
                <Typography style={{ fontSize: '15px' }}>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don’t look even slightly believable. If you are going to use a passage of Lorem Ipsum</Typography>
            </Grid>
            <Grid display='flex' flexDirection='row' style={{ margin: '2%' }}>
                <Typography style={{ color: '#008EA1', fontSize: '15px', marginRight: '25%' }}>Is this an Emergency &nbsp; <span style={{ color: '#000000', fontSize: '15px' }}>Yes</span></Typography>
                <Typography style={{ color: '#008EA1', fontSize: '15px' }}>Is this a Recurring issue &nbsp; <span style={{ color: '#000000', fontSize: '15px' }}>Yes</span> </Typography>
            </Grid>
        </Grid>
    );

};

export default JobDetails;